import React from "react";
import styles from "./App.module.css";
import Info from "./components/Info";
import TopLogos from "./components/TopLogos";
import MoreInfo from "./components/MoreInfo";
import Footer from "./components/Footer";
import SwmcFooter from "./components/SwmcFooter";

export function App() {
  return (
    <div className={styles.App}>
      <TopLogos />
      <Info />
      <MoreInfo />
      <Footer />
      <SwmcFooter />
    </div>
  );
}

export default App;
